const menuActionTypes = {
    TOGGLE_MENU_VISIBLE: 'TOGGLE_MENU_VISIBLE',
    HIDE_MENU: 'HIDE_MENU'
}

export default menuActionTypes;